﻿import {ref} from "vue";

const ENGLISH = "en";

export const storageDefaultNamespace = ref("aunoa");
export const locales = ref([ENGLISH]);
export const defaultLocale = ref(ENGLISH);
export const fallbackLocale = ref(ENGLISH);

